export const heroBanners = [
  {
    id: 1,
    title: '2024年度热播大剧',
    subtitle: '《长安十二时辰》第二季',
    description: '全明星阵容倾情演绎，史诗级古装悬疑巨制，每周五晚8点准时更新',
    badge: '全网独播',
    imageSeq: 'hero-banner-01',
  },
  {
    id: 2,
    title: '热门综艺全新一季',
    subtitle: '《奔跑吧》第十二季',
    description: '全新阵容，爆笑升级，每周六晚黄金档不见不散',
    badge: '热播中',
    imageSeq: 'hero-banner-02',
  },
  {
    id: 3,
    title: '精品纪录片系列',
    subtitle: '《风味人间》第五季',
    description: '探寻中华美食文化，品味人间烟火气息，高清4K画质呈现',
    badge: '高分推荐',
    imageSeq: 'hero-banner-03',
  },
];

export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-2-line' },
  { id: 'drama', name: '电视剧', icon: 'ri-tv-line' },
  { id: 'movie', name: '电影', icon: 'ri-film-line' },
  { id: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { id: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { id: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { id: 'short-video', name: '短视频', icon: 'ri-smartphone-line' },
  { id: 'kids', name: '少儿', icon: 'ri-user-smile-line' },
  { id: 'sports', name: '体育', icon: 'ri-basketball-line' },
  { id: 'music', name: '音乐', icon: 'ri-music-line' },
];

export const recommendedVideos = [
  {
    id: 1,
    title: '长安十二时辰 第二季',
    category: '电视剧',
    rating: 9.6,
    views: '2.3亿',
    updateInfo: '更新至第18集',
    badge: '热播',
    imageSeq: 'rec-video-01',
  },
  {
    id: 2,
    title: '流浪地球3',
    category: '电影',
    rating: 9.4,
    views: '5.1亿',
    updateInfo: '4K超清',
    badge: '高分',
    imageSeq: 'rec-video-02',
  },
  {
    id: 3,
    title: '奔跑吧 第十二季',
    category: '综艺',
    rating: 8.9,
    views: '3.7亿',
    updateInfo: '更新至第8期',
    badge: '热门',
    imageSeq: 'rec-video-03',
  },
  {
    id: 4,
    title: '风味人间 第五季',
    category: '纪录片',
    rating: 9.8,
    views: '1.8亿',
    updateInfo: '全10集',
    badge: '精品',
    imageSeq: 'rec-video-04',
  },
  {
    id: 5,
    title: '斗破苍穹 年番',
    category: '动漫',
    rating: 9.2,
    views: '4.5亿',
    updateInfo: '更新至第52集',
    badge: '热播',
    imageSeq: 'rec-video-05',
  },
  {
    id: 6,
    title: '乘风破浪的姐姐 第五季',
    category: '综艺',
    rating: 8.7,
    views: '2.9亿',
    updateInfo: '更新至第6期',
    badge: '热门',
    imageSeq: 'rec-video-06',
  },
  {
    id: 7,
    title: '大江大河3',
    category: '电视剧',
    rating: 9.3,
    views: '1.6亿',
    updateInfo: '更新至第24集',
    badge: '精品',
    imageSeq: 'rec-video-07',
  },
  {
    id: 8,
    title: '哪吒之魔童闹海',
    category: '电影',
    rating: 9.7,
    views: '8.2亿',
    updateInfo: '1080P高清',
    badge: '必看',
    imageSeq: 'rec-video-08',
  },
];

export const features = [
  {
    id: 1,
    title: '正版高清',
    description: '所有内容均为正版授权，支持1080P、4K超高清画质，带给您影院级观看体验',
    icon: 'ri-4k-line',
  },
  {
    id: 2,
    title: '多端同步',
    description: '手机、平板、电脑、电视四端全覆盖，随时随地无缝切换，进度自动同步',
    icon: 'ri-device-line',
  },
  {
    id: 3,
    title: '智能推荐',
    description: '基于AI智能算法，根据您的观看偏好精准推荐，发现更多心仪好内容',
    icon: 'ri-magic-line',
  },
  {
    id: 4,
    title: '海量内容',
    description: '汇集全网热门影视、综艺、动漫、纪录片等海量资源，总有一款适合您',
    icon: 'ri-database-2-line',
  },
];

export const stats = [
  { value: '10亿+', label: '累计播放量', icon: 'ri-play-circle-line' },
  { value: '5000万+', label: '注册用户', icon: 'ri-user-line' },
  { value: '3万+', label: '正版内容', icon: 'ri-file-video-line' },
  { value: '99.7%', label: '用户好评率', icon: 'ri-thumb-up-line' },
];

export const articles = [
  {
    id: 1,
    title: '《长安十二时辰》第二季热播，口碑再创新高',
    summary: '备受期待的《长安十二时辰》第二季自开播以来，凭借精良的制作和扣人心弦的剧情，收获观众一致好评。豆瓣评分持续走高，成为年度最具话题性的古装剧集之一。',
    category: '影视资讯',
    date: '2024-12-15',
    imageSeq: 'article-01',
    readCount: '12.8万',
  },
  {
    id: 2,
    title: '豆花视频荣获2024年度最佳视频平台奖',
    summary: '在刚刚结束的2024中国互联网大会上，豆花视频凭借优质的内容生态和出色的用户体验，荣获"年度最佳视频平台"称号。这是对豆花视频团队多年努力的肯定。',
    category: '平台动态',
    date: '2024-12-10',
    imageSeq: 'article-02',
    readCount: '8.5万',
  },
  {
    id: 3,
    title: '春节档电影即将上线，多部大片等你来看',
    summary: '2025年春节档多部重磅电影已确认登陆豆花视频平台，包括《流浪地球3》、《封神第二部》等热门大片，会员用户可享优先观看权益。',
    category: '内容预告',
    date: '2024-12-08',
    imageSeq: 'article-03',
    readCount: '15.2万',
  },
  {
    id: 4,
    title: '豆花视频APP全新版本发布，体验全面升级',
    summary: '豆花视频APP 6.0版本正式上线，全新UI设计带来更流畅的交互体验。新增AI智能字幕、画中画播放、离线缓存优化等功能，让观影更加便捷舒适。',
    category: '产品更新',
    date: '2024-12-05',
    imageSeq: 'article-04',
    readCount: '6.3万',
  },
];

export const faqs = [
  {
    question: '豆花视频会员有哪些权益？',
    answer: '豆花视频会员可享受免广告观看、超高清4K画质、VIP专享内容、离线缓存、多端同步播放等多项专属权益。会员分为月度、季度和年度三种套餐，年度会员性价比最高。',
  },
  {
    question: '如何下载豆花视频APP？',
    answer: '您可以在苹果App Store、华为应用市场、小米应用商店、OPPO软件商店等各大应用商店搜索"豆花视频"下载。也可以通过官网首页底部的下载二维码扫码安装。',
  },
  {
    question: '豆花视频支持哪些设备观看？',
    answer: '豆花视频支持手机（iOS和Android）、平板、电脑网页端以及智能电视（TV版）观看。同一个账号可在多个设备上登录使用，支持播放进度云端同步。',
  },
  {
    question: '视频加载缓慢怎么办？',
    answer: '建议您检查网络连接状态，可以尝试切换清晰度（如从4K切换到1080P）。如果问题依旧，请尝试清除APP缓存或重启设备。您也可以联系客服获取进一步帮助。',
  },
  {
    question: '如何取消自动续费？',
    answer: '您可以在豆花视频APP中进入"我的"→"会员中心"→"管理自动续费"进行取消操作。取消后当前会员周期不受影响，到期后不再自动续费。',
  },
];

export const downloadInfo = {
  title: '下载豆花视频APP',
  description: '随时随地，想看就看。扫码下载，新用户专享7天免费会员！',
  qrImageSeq: 'download-qr',
};